import { render } from "./SubDetails.vue?vue&type=template&id=3d33def2&scoped=true"
import script from "./SubDetails.vue?vue&type=script&lang=js"
export * from "./SubDetails.vue?vue&type=script&lang=js"

import "./SubDetails.vue?vue&type=style&index=0&id=3d33def2&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d33def2"]])

export default __exports__